/**
 * FundamentalChartService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class FundamentalChartService {
    getAllCompanies = () => {
        return apiClient.get("/getAllCompanies");
    }

    getMeasuresByTool = (body) => {
        return apiClient.post("/getMeasuresByTool", body);
    }

    getCategoriesByMeasure = (body) => {
        return apiClient.post("/getCategoryByMeasure", body);
    }

    getMetricsByCategory = (body) => {
        return apiClient.post("/getMetricByCategory", body);
    }

    getMetricsByTool = (body) => {
        return apiClient.post("/getMetricsByTool", body);
    }

    getRangesByMetric = (filter) => {
        return apiClient.get("/suggest_ranges/" + filter);
    }

    submitData = (body) => {
        return apiClient.post("/dataanalysis/fundamentalchart", body);
    }
}
